<template>
  <div style="height: 100%" class="contant">
    <!-- <jinanLogoVue class="ml20" style="margin-top: 20px; position: absolute;z-index: 99" /> -->
    <div id="poster" class="login">
      <div class="titleTop" style="font-size: 38px;z-index: 99;letter-spacing: 15px;">
        欢迎登录
        <!-- 同信消安智慧管理平台 -->
      </div>
      <el-form ref="user" :model="user" class="login-form mt10 login-back">
        <div class="loginTop" style="position: relative">
          <span
            class="flex center topColor"
            style="
              width: 50%;
              position: absolute;
              top: -15px;
              left: 0;
              right: 0;
              bottom: 0;
              margin: auto;
            "
            >登录入口
          </span>
        </div>
        <el-form-item prop="username">
          <div class="flex inputBox">
            <i class=" inputIcon el-icon-user"></i>
            <el-input v-model="user.username" type="text" auto-complete="off" placeholder="账号"> </el-input>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="flex inputBox">
            <i class="inputIcon el-icon-lock"></i>

            <el-input v-model="user.password" type="password" auto-complete="off" placeholder="密码" @keyup.enter.native="handleLogin"> </el-input>
          </div>
        </el-form-item>
        <!--      <el-form-item prop="code" v-if="captchaOnOff">-->
        <!--        <el-input-->
        <!--          v-model="user.code"-->
        <!--          auto-complete="off"-->
        <!--          placeholder="验证码"-->
        <!--          style="width: 63%"-->
        <!--          @keyup.enter.native="handleLogin"-->
        <!--        >-->
        <!--          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />-->
        <!--        </el-input>-->
        <!--        <div class="login-code">-->
        <!--          <img :src="codeUrl" @click="getCode" class="login-code-img"/>-->
        <!--        </div>-->
        <!--      </el-form-item>-->
        <div class=" gray" style=" display:flex;justify-content:flex-end">
          <el-checkbox v-model="saveNumber" style="margin: 0px 0px 25px 5px">记住账号</el-checkbox>
          <el-checkbox v-model="savePass" style="margin: 0px 0px 25px 5px;margin-left:20px">记住密码</el-checkbox>
        </div>

        <el-form-item class="mt10" style="width: 100%">
          <el-button :loading="loading" size="medium" class="inputBox" style="width: 100%" @click.native.prevent="submit">
            <span v-if="!loading" v-loading.fullscreen.lock="fullscreenLoading">登 录</span>
            <span v-else>登 录 中...</span>
          </el-button>
        </el-form-item>
      </el-form>
      <!--  底部  -->
      <div class="el-login-footer" style="z-index: 99;margin-bottom: 20px;">
        <!-- <span>Copyright © 2023 青岛同人建筑防火有限公司</span> -->
        <span class="ml10" style="margin-right:10px ;"> <a style="color:#fff" href="https://beian.miit.gov.cn">备案号:鲁ICP备17044344号-1</a></span>
      </div>
      <!-- <div class="flex loginbox">
            <div v-if="!$bus.isPhone" style="position: relative;flex: 5">
                <img src="../assets/img/loginbg.png" style="width: 100%;height: 100%">
                <div class="l-text">
                    <img src="../assets/img/logo1.png" alt="">
                    <div class="c-f mt10" style="font-size: 31px">同人智慧消防综合管理平台</div>
                </div>
            </div>
            <div :class="` l-r center ${$bus.isPhone?'phone':''}`" style="flex: 4;position:relative">
                <h3 class="login_title">登录</h3>
                <el-form class="login-container" label-position="left" label-width="0px" :model="user" :rules="rules" ref="user">
                    <el-form-item prop="username">
                        <el-input prefix-icon="el-icon-user" type="text" v-model="user.username" auto-complete="off" placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input prefix-icon="el-icon-lock" type="password" v-model="user.password" auto-complete="off" placeholder="请输入密码" show-password></el-input>
                    </el-form-item>
                    <el-form-item class="center f-right">
                        <el-checkbox label="记住账号" v-model="saveNumber">记住账号</el-checkbox>
                        <el-checkbox label="记住密码" v-model="savePass">记住密码</el-checkbox>
                    </el-form-item>
                    <div class="login-btn" :loading="loading" @click="submit">登 录</div>
                </el-form>
                <img src="../assets/img/erweima.png" style="width:13%;margin-top:2vw;height:12%" alt="">
               <p > 扫码下载物联app</p>
        <div class="footer center  ">
         &copy;青岛同人建筑防火有限公司  &nbsp; <span class="ml10"> <a href="https://beian.miit.gov.cn">鲁ICP备17044344号-1</a></span>
    </div>
            </div>
        </div> -->
      <div class="backgroundimg" style="height:100%"></div>
    </div>
  </div>
</template>
<script>
// import jinanLogoVue from "../components/jinanlogo/jinanLogo.vue";
import { login, getWeihu } from "../api/common.js";
export default {
  // components: { jinanLogoVue },
  data() {
    return {
      fullscreenLoading: false,
      user: {
        username: "",
        password: "",
      },
      rules: {
        username: [{ required: true, message: "账号不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
      savePass: true,
      saveNumber: true,
      loading: false,
    };
  },
  mounted() {},
  created() {
    if (this.$local.get("token")) {
      this.$router.replace("/");
    }
    if (this.$local.get("account")) {
      this.user = this.$local.get("account");
    }
    this.$local.remove("countList");
    this.$local.remove("bjstate");
    document.onkeydown = (e) => {
      //按下回车提交
      let key = window.event.keyCode;
      //事件中keycode=13为回车事件
      if (key == 13) {
        this.submit();
      }
    };
  },
  methods: {
    submit() {
      this.$refs["user"].validate((valid) => {
        if (valid) {
          if (this.savePass) {
            this.$local.save("account", this.user);
          } else {
            this.$local.remove("account");
          }
          this.login();
        } else {
          return false;
        }
      });
    },
    login() {
      this.loading = true;
      // this.$loading;

      //      var obj = this.$store.state.weihutime
      //   if(obj.endtime && obj.starttime && !this.$store.state.isDev ) {
      //           this.$alert(`尊敬的客户,我们将于 ${obj.starttime} 至 ${obj.endtime} 进行系统升级维护，维护期间系统暂时无法登入，给您造成不便，敬请谅解。`, '公告', {
      //       confirmButtonText: '确定',

      //     });
      //      }
      // setTimeout(() => {
      //   window.location.reload();
      // }, 800);

      this.$store
        .dispatch("Login", this.user)
        .then((res) => {
          if (res.data.natureId != 2) {
            this.$router.push("/Homepage1");
          } else {
            // console.log(11111);
            // console.log(2222);
            this.$router.push("/");
          }
          setTimeout(() => {
            window.location.reload();
          }, 800);
        })
        .catch((er) => {
          this.loading = false;
          // this.getCode();
        });
      //    login(this.user).then(res=>{
      //         this.loading = false
      //         if(res.code==200){
      //             this.$message({
      //                 message: res.msg,
      //                 type: 'success'
      //             });
      //             if(this.savePass){
      //                 this.$local.save('account',this.user)
      //             }else{
      //                 this.$local.remove('account')
      //             }
      //             this.$store.commit('saveUser',res.data)
      //             //window.location.href = '/'
      //             this.$router.push('/')
      //         }
      //     }).catch(res=>{
      //         this.loading = false
      //         //this.$message.error('登录失败！')
      //     })
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.contant {
  background: #032e66;
}
.topColor {
  color: rgba(255, 255, 255, 1);
  text-shadow: 0px 0px 5px 0px rgba(166, 240, 255, 1);
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: red;
  background-size: cover;
}
.backgroundimg {
  background-image: url("../assets/logo/logijinan.png");
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  // opacity: 0.2;
  // z-index: 54;
  // width: 1920px;
  // height: 1080px;
  // opacity: 1;
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  z-index: 99;
  border-radius: 6px;
  width: 480px;
  padding: 25px 25px 5px 25px;

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 22px;
  }
}
.login-back {
  padding: 50px;
  width: 540px;
  height: 390px;
  background-image: url("../assets/logo/jinanLogin.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 99;

  // //   border:1px solid #000;
  // //   border-radius: 10px 10px 0 0 ;
  //   background: linear-gradient(135deg, transparent 10px, rgba(38, 117, 191, 0.8) 0) top left,
  //     linear-gradient(-135deg, transparent 10px, rgba(38, 117, 191, 0.8) 0) top right,
  //     linear-gradient(-45deg, transparent 0px,  rgba(38, 117, 191, 0.8) 0) bottom right,
  //     linear-gradient(45deg, transparent 0px,  rgba(38, 117, 191, 0.8) 0) bottom left;
  //   background-size: 50% 50%;
  //   background-repeat: no-repeat;
}
.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}
.login-code {
  width: 33%;
  height: 38px;
  float: right;
  img {
    cursor: pointer;
    vertical-align: middle;
  }
}
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}
.login-code-img {
  height: 38px;
}
</style>
<style lang="scss" scoped>
$inputColor: rgba(0, 213, 255, 1);
::v-deep .el-checkbox {
  color: $inputColor;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  margin-right: 30px;
}
.inputIcon {
  color: rgba(0, 213, 255, 1);
  width: 5%;
  text-align: center;
  display: flex;
  align-items: center;
  margin-left: 10px;
  justify-content: center;
  font-size: 18px;
}
::v-deep .el-checkbox__inner {
  display: inline-block;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  width: 14px;
  height: 14px;
  background-color: none;
  z-index: 1;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46), background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
::v-deep .el-input__inner {
  -webkit-appearance: none;
  // background-color: red ;
  background: none;
  border-radius: 4px;
  border: none;
  box-sizing: border-box;
  border: 1px solid rgba(16, 106, 172, 1);
  border-left: none;
  color: $inputColor;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
}

::v-deep .el-input__inner::placeholder {
  color: $inputColor;
}
.inputBox {
  color: $inputColor;

  background: url("~@/assets/logo/inputBg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border: none;
  &:hover {
    background: url("~@/assets/logo/inputBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    border: none;
    color: rgb(46, 217, 251);
  }
}

.loginTop {
  // background-image: url("../assets/logo/backBorder.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -10px;

  font-size: 20px;
  margin-bottom: 30px;
  height: 40px;
}
.titleTop {
  margin-bottom: 25px;
  color: red;
  color: rgba(112, 231, 255, 1);
}
.login {
  flex-direction: column;
}
.login-form {
}
.title {
  font-size: 24px;
}
.agre {
  line-height: 20px;
  letter-spacing: 1px;
}
</style>
